import React from 'react';

interface HeroProps {
  onCtaClick: () => void;
}

const Hero: React.FC<HeroProps> = ({ onCtaClick }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
      {/* Background Gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-simios-accent/10 blur-[120px]"></div>
        <div className="absolute bottom-[10%] right-[-5%] w-[30%] h-[30%] rounded-full bg-blue-600/10 blur-[100px]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-block mb-6 px-4 py-1.5 rounded-full border border-simios-accent/30 bg-simios-accent/10 text-simios-accent text-sm font-semibold tracking-wide uppercase">
          Innovation &bull; Strategy &bull; Technology
        </div>
        
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight text-white mb-8">
          Bridging Finance, <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-simios-accent to-emerald-300">
            Tech & Leadership.
          </span>
        </h1>

        <p className="mt-4 max-w-2xl mx-auto text-xl text-simios-muted mb-10">
          Simios combines expert board advisory with cutting-edge app development. 
          Led by Simon Loftus, transforming ideas into scalable fintech and edtech realities.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={onCtaClick}
            className="px-8 py-4 bg-simios-accent text-white text-lg font-bold rounded hover:bg-simios-accentHover transition-all shadow-lg shadow-simios-accent/20"
          >
            Explore Services
          </button>
          <button 
            onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-4 bg-transparent border border-gray-600 text-white text-lg font-medium rounded hover:bg-white/5 transition-all"
          >
            View Our Products
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;